import { BaseElementDefBase, BaseControlDef } from "./BaseElementDef";
import { FormDefinitionItem } from "./__DefinitionDataInterface";
import { FormControlItem } from "@cs/FormControlItem";
import { TextboxSettings } from "@cs-ts/textbox-settings";
import { CalculationContext } from "./__CalculationContextInterface";
import { timer } from "rxjs";
import { debounce, map } from "rxjs/operators";
import { isNullOrWhitespace } from "@/lib/whitespaceMethods";

export default class TextboxDef extends BaseControlDef<TextboxSettings, FormDefinitionItem<TextboxSettings>, FormControlItem, string> {
    constructor(parentElement: BaseElementDefBase | null, elementData: FormControlItem, definitionData: FormDefinitionItem<TextboxSettings>, calculationContext: CalculationContext) {
        super(parentElement, elementData, definitionData, calculationContext);
        this.typeName = "MI.Common.DynamicForms.Models.DFTextbox"; // TODO - not hardcoded?
        this.autoEdit = false;
        this.isFocusable = true;
    }
    valueList$() {
        const baseList = super.valueList$();
        if (this.calculationContext.nonLiveTextboxes || this.forceNonLive) {
            return baseList;
        } else {
            return baseList.pipe(TextboxDef.debounceExceptFirst(TextboxDef.debounceValueTime));
        }
    }

    effectiveValueList$() {
        const baseList = super.effectiveValueList$();
        if (this.calculationContext.nonLiveTextboxes || this.forceNonLive) {
            return baseList;
        } else {
            return baseList.pipe(
                TextboxDef.debounceExceptFirst(TextboxDef.debounceValueTime),
                //tap(v => {
                //    console.log(`2 - Redoing effectiveValueList$ for ${this.definition.id} - Z - ${JSON.stringify(v)}`);
                //})
            );
        }
    }

    maskedValue$() {
        return this.effectiveValueList$().pipe(map(([i]) => [...TextboxDef.maskValue(i, this.definition.settings.effectiveOutputMask!)]));
    }

    _maskedValue$() {
        return this.maskedValue$();
    }

    _effectiveLabelText$() {
        return this.effectiveLabelText$();
    }

    static debounceValueTime = 500;
    static debounceExceptFirst(time: number) {
        let first = true;
        return debounce((i: string[]) => {
            if (!first) {
                return timer(time);
            }
            first = false;
            return timer(0);
        });
    }
    static maskValue(value: string | null, outputMask: string | undefined) {
        if (!value || isNullOrWhitespace(value)) {
            return [];
        }
        if (!outputMask || isNullOrWhitespace(outputMask)) {
            return [value];
        }
        let result = "";
        for (let index = 0; index < outputMask.length; index++) {
            const cha = outputMask[index];
            if (/\w/.test(cha)) {
                if (index < value.length) {
                    result += value[index];
                }
            } else {
                result += outputMask[index];
            }
            if (result.length == value.length) {
                break;
            }
        }
        return outputMask != null ? [result] : [];
    }
}
